// extracted by mini-css-extract-plugin
export var dataCell = "_pp-2";
export var dataRow = "_pp-0";
export var headerRow = "_pp-1";